
<div
  :id="vnodeId"
  class="cvt-editor-text"
  :class="editorClasses"
  draggable="false"
  @mouseover="target"
  @click="enableEditor"
  @dblclick="resizeContent"
  @contextmenu="showContextMenuIfNotEditing($event)"
  @dragstart="dragstart"
  @dragend="dragend"
>
  <drag-and-drop-zone
    :z-index="dropzoneZIndex"
    @dropped="addElementToSide"
  />

  <!-- main vdom node -->
  <div
    class="draft-editor"
    :class="draftStyleClasses"
  >
    <div
      class="froala-editor"
      v-html="contentsHTML"
    />
  </div>
  <template v-if="showActionButtonsOnClick && !isGridBuilder">
    <!--THis is only here because of freshwork in v1 gridbuilder,
    once they migrate to v2 or v3, it will become irrelevant-->
    <action-buttons
        v-if="selected"
        @duplicate="duplicateAndValidate"
        @remove="removeAndValidate"
    />
  </template>
</div>
